/**
 * Image locale avec WebP + fallback PNG (ou img simple pour URLs externes).
 */
export default function OptimizedImage({
    src,
    alt = "",
    className = "",
    width,
    height,
    loading,
    decoding = "async",
    fetchPriority,
    srcSet,
    sizes,
    ...rest
}) {
    const isLocalPng =
        typeof src === "string" &&
        src.startsWith("/images/") &&
        src.endsWith(".png");
    const isLocalWebp =
        typeof src === "string" &&
        src.startsWith("/images/") &&
        src.endsWith(".webp");

    if (isLocalWebp || isLocalPng) {
        const webp = isLocalWebp ? src : src.replace(/\.png$/i, ".webp");
        const png = isLocalPng ? src : src.replace(/\.webp$/i, ".png");
        return (
            <picture>
                <source srcSet={srcSet || webp} type="image/webp" sizes={sizes} />
                <img
                    src={png}
                    alt={alt}
                    className={className}
                    width={width}
                    height={height}
                    loading={loading}
                    decoding={decoding}
                    fetchPriority={fetchPriority}
                    sizes={sizes}
                    {...rest}
                />
            </picture>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            width={width}
            height={height}
            loading={loading}
            decoding={decoding}
            fetchPriority={fetchPriority}
            srcSet={srcSet}
            sizes={sizes}
            {...rest}
        />
    );
}
